
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2604_3778)"}},[_c('path',{staticClass:"stroke",attrs:{"d":"M12.3 3.517c2.113 0 6.446 1.585 6.868 5.813v6.34c0 2.114 2.114 3.7 2.114 3.7.529.528.529 1.585-1.057 1.585H12.3M12.3 3.517c-2.115 0-6.448 1.585-6.87 5.813v6.34c0 2.114-2.114 3.7-2.114 3.7-.528.528-.528 1.585 1.057 1.585h7.926","stroke":"#00003C"}}),_c('path',{staticClass:"stroke",attrs:{"d":"M10.926 1.929c.529-.7 2.114-.7 2.642 0","stroke":"#00003C","stroke-linecap":"round"}}),_c('path',{staticClass:"stroke active-highlight",attrs:{"d":"M9.87 23.071c.528.7 4.227.7 4.755 0","stroke":"#E2E4EC","stroke-linecap":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2604_3778"}},[_c('path',{staticClass:"stroke",attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    